export default "__VITE_ASSET__DXR976xB__"